export const theme = {
  fontFamily: "Source Sans Pro, Helvetica, Arial, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif",
}
